import { Factory } from '../../services/Factory';
import { StateService } from '../../services/state/StateService';
import { AccountService } from '../../services/account/AccountService';
import { TokenService } from '../../services/authentication/TokenService';
import { INotificationService } from '../../services/notification';

export interface ILoginScope extends angular.IScope {
}

export class Login implements angular.IDirective {
  public restrict: string = "E";
  public link: (scope: ILoginScope, element: angular.IAugmentedJQuery) => void;
  public templateUrl: string;

  constructor($uibModal, $location: any, stateService: StateService, accountService: AccountService, tokenService: TokenService, notificationService: INotificationService) {
    this.templateUrl = "partials/login.html";
    this.link = (scope) => {
        scope.showForm = stateService.IsLoggedOut();
        scope.account = accountService;

        scope.$on(EVENTS.LOGIN_REQUIRED, () => scope.showForm = true);
        scope.$on(EVENTS.LOGIN_CONFIRMED, () => scope.showForm = false);

        const showFailure = (description?: string) => {
          if (!description) {
            description = "Your login credentials were incorrect";
          }

          notificationService.addError({
            title: "Sign in Failure",
            description: description,
            buttons: `<button ng-controller="ResetPasswordButtonCtrl" ng-click="openResetPasswordDialog()" class="btn btn-danger">Reset your password</button>`
          });
        };

        scope.loginInputChanged = function () {
          // if there are any notifications, dismiss the sign in failure notification when user changes login input
          if(notificationService.getCurrentMessages().length > 0) {
            const index = notificationService.indexOfMessage({"title": "Sign in Failure"});
            if (index !== -1) {
              notificationService.dismiss(index);
            }
          }
        };

        scope.submit = function (login) {
          if (!login) {
            showFailure();
            return;
          }

          console.log("Auth submit");

          scope.email = login.email;
          scope.password = login.password;

          tokenService.Fetch(login.email, login.password)
            .error((data) => {
              console.log(data);

              let description = "";

              if (data && data.error === "MFARequiredException") {
                scope.token = data.MFAToken;
                scope.phoneNumber = data.PhoneNumber;

                tokenService.CheckStatus(login.email, login.password, data.MFAToken)
                  .success(data => {
                    console.log(data);

                    scope.loginMode = true;
                    scope.step = 1;

                    let mfaModalInstance = $uibModal.open({
                      backdrop: true,
                      keyboard: true,
                      backdropClick: true,
                      templateUrl: "partials/mfa/dialog_mfa.html",
                      controller: "MFAModalController",
                      scope: scope,
                      resolve: {
                        account: () => scope.account
                      }
                    });

                    mfaModalInstance.result.then(success => {
                      if (success) {
                        notificationService.dismissAll();

                        accountService.Fetch()
                          .success((data) => {
                            notificationService.addInfo({
                              title: "Welcome back " + accountService.GetFirstName(),
                              timeout: 5000
                            });
                          }).error(data => {
                          console.log(data)
                        });

                        stateService.SetLoggedIn();

                        login.email = "";
                        login.password = "";

                        $location.path("/project");
                      }
                    });
                  })
                  .error(data => console.log(data));
              } else {
                if (data && _.has(data, "error_description")) {
                  description = data["error_description"];
                }

                if (description === "User is disabled") {
                  notificationService.addError({
                    title: "Sign in Failure",
                    description: description,
                    buttons: `<a href="mailto:folio_support@innovativedriven.com" class="btn btn-primary"><i class="fas fa-mail"></i> Contact Support</a>`
                  });
                } else {
                  showFailure(description);
                }

                stateService.SetLoggedOut();
              }
            });
        };

        scope.logout = () => {
          notificationService.dismissAll();

          notificationService.addFlashSuccess({
            title: "Signed out",
            description: "You have successfully signed out",
            timeout: 5000
          });

          stateService.SetLoggedOut();
          $location.path("/");
        };
      }
    }
  }

frontendApp.directive("iioLogin", ["$uibModal", "$location", "StateService", "AccountService", "TokenService", "NotificationService", "PreferenceService", Factory.Create(Login)]);
